/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { db_DropdownSubjectArea } from '../models/db_DropdownSubjectArea';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SubjectAreas {
    /**
     * Get a list of subject areas
     * @returns db_DropdownSubjectArea OK
     * @throws ApiError
     */
    public static listSubjectAreas(): CancelablePromise<Array<db_DropdownSubjectArea>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/subject-areas',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
